import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

export default class DevView extends Component {
  render() {
    return (
      <div className="portfolio__block__about-me--dev">
        <Row>
          <Col>
            <p>
              <strong>Code</strong>
            </p>
            <p>200</p>
          </Col>
          <Col className="portfolio__block__about-me--dev__code">
            <pre>
              <code>{JSON.stringify(this.props.data, null, 2)}</code>
            </pre>
          </Col>
        </Row>
      </div>
    );
  }
}
